import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import './styles.css'

const clientId = process.env.REACT_APP_CLIENT_ID

export default compose(
  inject('i18n'),
  observer
)(({
  _id,
  slug,
  legacy,
  website,
  code,
  name,
  startDate,
  thumbnailUrl,
  location,
  coverUrl,
  whiteLabelUrl,
  i18n: { locale }
}) => {
  // console.log('_id', _id)
  // console.log(toTime(startDate))
  function toDay (time) {
    return moment(time).format('DD')
  }
  function toMonth (time) {
    return moment(time).format('MMM YYYY')
  }
  // function toTime (time) {
  //   return moment(time).format('h.mm a')
  // }
  return (
    <div className="eventCardBox">
      <div className="eventCard">
        <img className="eventCardImg" src={thumbnailUrl} alt="" />
        <div className="eventCardDetail">
          <div className="eventCardDateBox">
            <div className="eventCardDateBoxContent">
              <div className="eventCardDateBoxText">
                {toDay(startDate)}
              </div>
              <div className="eventCardDateBoxTextMonth">
                {toMonth(startDate)}
              </div>
            </div>
          </div>
          <div className="infoRigtSide">
            <span className="eventCardEventTitle">{name[locale]}</span><br />
            <span>
              {location &&
                <span>
                  <i className="material-icons">location_on</i> {location}
                </span>}
            </span>
            <br />
          </div>
          <div className="eventCardRegisterBox">
            <div className="btnWrapper">
              {legacy
                ? website &&
              <a
                href={website}
                className="eventCardRegisterBtn"
                target="_blank"
              >
                    Website
              </a>
                : ((!whiteLabelUrl || clientId)
                  ? <Link to={`/events/${slug}`} className="eventCardRegisterBtn">
                    <FormattedMessage id="app.register" defaultMessag="Register" />
                  </Link>
                  : <a href={whiteLabelUrl} className="eventCardRegisterBtn" target="_blank">
                    <FormattedMessage id="app.register" defaultMessag="Register" />
                  </a>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

/* <Col lg={8} sm={12}>
      <div className="running-card">
        <div className="img-cover">
          <img src={coverUrl} style={{ width: '100%' }} />
        </div>
        <h2>{name.en}</h2>
        <div className="raceday">
          <h3>
            <i className="fa fa-calendar"> Race Day </i>
          </h3>
          <p>{toTime(startDate)}</p>
        </div>
        <div className="status">
          <h3>
            <i>Status</i>
          </h3>
          <p>UP COMMING</p>
        </div>
        <Link className="register-btn" to={`/events/${slug}`}>More Info</Link>
      </div>
    </Col> */



// WEBPACK FOOTER //
// ./src/App/EventListPage/EventItem/EventItem.js